import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./Inbox.css";

const VALID_ROLES = ["agent", "scout", "club"];

function normalizeRole(r) {
    const role = String(r || "").toLowerCase();
    return VALID_ROLES.includes(role) ? role : "agent";
}

const Inbox = ({
    role: roleProp,
    userId,
    id,
    agentId,
    scoutId,
    clubId,
}) => {
    const navigate = useNavigate();

    // Normalize role
    const role = normalizeRole(roleProp);

    // Resolve actor id
    const actorId = userId || id || agentId || scoutId || clubId;

    // Base dashboard path
    const dashboardBase = `/${role}-dashboard`;

    // ✅ MUST MATCH routesRegistry EXACTLY
    const actions = useMemo(() => {
        switch (role) {
            case "scout":
                return [
                    { label: "Chats", path: "chats" },
                    { label: "Scout Reporting", path: "report" },
                    { label: "VSN World", path: "vsn-world" },
                ];
            case "club":
                return [
                    { label: "Chats", path: "chats" },
                    { label: "Club Reporting", path: "report" },
                    { label: "VSN World", path: "vsn-world" },
                ];
            case "agent":
            default:
                return [
                    { label: "Chats", path: "chats" },
                    { label: "Agent Reporting", path: "report" },
                    { label: "VSN World", path: "vsn-world" },
                ];
        }
    }, [role]);

    const handleNavigate = (subPath) => {
        if (!actorId) {
            console.error("[Inbox] Missing actorId", {
                role,
                userId,
                agentId,
                scoutId,
                clubId,
            });
            return;
        }

        navigate(`${dashboardBase}/${subPath}`, {
            state: { role, userId: actorId },
        });
    };

    return (
        <div className={`role-inbox ${role}-inbox`}>
            <div className="inbox-card">
                <h3 className="card-title">Inbox</h3>

                <div className="button-stack">
                    {actions.map((a) => (
                        <button key={a.path} onClick={() => handleNavigate(a.path)}>
                            {a.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Inbox;

